export const restrictChars = ',.';
